/* import __COLOCATED_TEMPLATE__ from './slack-integration-expired-banner.hbs'; */
/* RESPONSIBLE TEAM: team-omni */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { dropTask } from 'ember-concurrency-decorators';
import { taskFor } from 'ember-concurrency-ts';
import type { TaskGenerator } from 'ember-concurrency';
import type { Router } from '@ember/routing';
import type Session from 'embercom/services/session';
import type SlackIntegrationService from 'embercom/services/slack-integration-service';

interface Args {}

interface Signature {
  Element: HTMLButtonElement;
  Args: Args;
}

export default class SlackIntegrationExpiredBanner extends Component<Signature> {
  @service declare router: Router;
  @service declare session: Session;
  @service declare slackIntegrationService: SlackIntegrationService;

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    taskFor(this.loadSlackIntegration).perform();
  }

  @dropTask
  *loadSlackIntegration(): TaskGenerator<void> {
    yield this.slackIntegrationService.loadIntegration();
  }

  get isStale() {
    return this.slackIntegrationService.hasStaleIntegration || false;
  }

  @action redirectToSettings() {
    this.router.transitionTo('apps.app.settings.channels.slack', this.session.workspace.id);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::SlackIntegrationExpiredBanner': typeof SlackIntegrationExpiredBanner;
  }
}
